const initialProps = {
  currentUser: {},
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_STATE_USER":
      return {
        ...state,
        currentUser: action.payload,
      };
    default:
      return state;
  }
}
